import { z } from 'zod';

export const GetAccessTokenResponseDto = z.object({
  accessToken: z.string(),
  refreshToken: z.string(),
});

export type TGetAccessTokenResponseDto = z.infer<typeof GetAccessTokenResponseDto>;
